import PersonalizationTags from './PersonalizationTags'
export default PersonalizationTags
